import { render } from "./MicrophoneOutline.vue?vue&type=template&id=5ef38d05"
import script from "./MicrophoneOutline.vue?vue&type=script&lang=js"
export * from "./MicrophoneOutline.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__